package com.ervasstudio.tracoemovimento.components.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.ervasstudio.tracoemovimento.components.custumcomponents.layout.MdMenuDropdown
import com.ervasstudio.tracoemovimento.components.custumcomponents.layout.MenuCentral
import com.ervasstudio.tracoemovimento.components.custumcomponents.layout.MenuAuht
import com.ervasstudio.tracoemovimento.model.Paginas
import com.ervasstudio.tracoemovimento.util.Res
import com.ervasstudio.tracoemovimento.util.Res.MyColors.Lilas
import com.huanshankeji.compose.html.material3.MdLinearProgress
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import kotlinx.browser.window
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px

@Composable
fun HeaderCursos(isMobile: Boolean) {
    val ctx = rememberPageContext()

    val localStorageNameKey = "nomeAluno"
    var paginaIndex by remember { mutableStateOf(true) }
    var nomeUser: String? by remember { mutableStateOf("") }
    var emailUser by remember { mutableStateOf("") }
    val coroutineScope = rememberCoroutineScope()


    val auth = Firebase.auth
    var isLoading by remember { mutableStateOf(true) }
    var isLoggedIn by remember { mutableStateOf(false) }

    // Observa o estado de autenticação em tempo real
    LaunchedEffect(Unit) {
        auth.authStateChanged.collect { user ->
            isLoggedIn = (user != null)
            isLoading = false // O Firebase terminou de checar o storage do navegador
            nomeUser=""
            delay(3000)
            nomeUser = window.localStorage.getItem(localStorageNameKey)

        }

    }


    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(
                top =  if (isMobile) 2.px else 5.px ,
                right = if (isMobile) 8.px else 20.px,
                bottom = if (isMobile) 2.px else 5.px,
                left = if (isMobile) 8.px else 20.px
            )
            .backgroundColor(Lilas)
            .position(Position.Sticky)
            .top(0.px)
            .left(12.px)
            .zIndex(9),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {

        Row(
            modifier = Modifier.weight(1),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Start
        ) {
            Image(
                modifier = Modifier.width(if(isMobile) 80.px else 250.px).objectFit(ObjectFit.Cover),
                src = Res.Image.logo,

                )

        }

        Row(
            modifier = Modifier.weight(1).gap(if (isMobile) 6.px else 20.px),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Center
        ) {
            MenuCentral(
                onClick = { ctx.router.navigateTo(it) },
                currentPath = ctx.route.path,
                isLogdeIn = isLoggedIn,
                isMobile = isMobile
            )
        }



        Row(
            modifier = Modifier.weight(1).gap(if (isMobile) 6.px else 20.px),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.End
        ) {


            if (isLoading) {
                MdLinearProgress(
                    indeterminate = true,
                    attrs = {
                        classes("progress-white")
                    },

                )
            }else{
                if(isLoggedIn){

                    MdMenuDropdown(
                        nome = nomeUser,
                        onLogoutClick = {
                            coroutineScope.launch {
                                auth.signOut()
                                ctx.router.navigateTo(Paginas.CURSOS.rota)
                            }
                        },
                        onPerfilClick = {},
                        onPagamentosClick = {},
                        onAjudaClick = {},
                        isMobile = isMobile,
                    )

                }else{
                    MenuAuht(
                        currentPath = ctx.route.path,
                        onClick = { ctx.router.navigateTo(it) },
                        isMobile = isMobile
                    )
                }
            }

        }

    }
}




